"use strict";

var FormStatus = /* @__PURE__ */(FormStatus2 => {
  FormStatus2["Success"] = "success";
  FormStatus2["Error"] = "error";
  return FormStatus2;
})(FormStatus || {});
var NewsletterSubscribeErrorCode = /* @__PURE__ */(NewsletterSubscribeErrorCode2 => {
  NewsletterSubscribeErrorCode2["MissingEmail"] = "MissingEmail";
  NewsletterSubscribeErrorCode2["InvalidEmail"] = "InvalidEmail";
  NewsletterSubscribeErrorCode2["InvalidStoreId"] = "InvalidStoreId";
  NewsletterSubscribeErrorCode2["TooManyRequests"] = "TooManyRequests";
  NewsletterSubscribeErrorCode2["Generic"] = "Generic";
  return NewsletterSubscribeErrorCode2;
})(NewsletterSubscribeErrorCode || {});
export { FormStatus, NewsletterSubscribeErrorCode };
//# sourceMappingURL=Footer.types.mjs.map
